export default (function (language) {
  var strings = {
    en: {
      emailLabel: 'Email'
    }
  };
  var usingLanguage = Object.keys(strings).indexOf(language) === -1 ? 'en' : language;
  return strings[usingLanguage];
});